import { DateTime as n } from "luxon";
function m(t) {
  const e = t.end.getMonth() - t.start.getMonth(), a = (t.end.getFullYear() - t.start.getFullYear()) * 12;
  return 1 + e + a;
}
function s(t, e) {
  const a = n.fromJSDate(t), r = n.fromJSDate(e);
  return a.hasSame(r, "day");
}
export {
  m as getCalendarsByPeriod,
  s as isSameDay
};
